//import stickybits polyfill to ensure position:sticky works in ie11
import stickybits from 'stickybits';

// Breakpoints
var mqL = window.matchMedia('(min-width: 768px)');

var stickyHeader;
var stickyTabcontainer;
var ingredientHeaderSticky = function () {
    if (mqL.matches) {
        stickyHeader = stickybits('header.trigger-gradient', {
            useStickyClasses: true
        });
        stickyTabcontainer = stickybits('.tab-container--sticky', {
            stickyBitStickyOffset: 192,
            useStickyClasses: true
        });
    } else {
        if (stickyHeader || stickyTabcontainer) {
            stickyHeader.cleanup();
            stickyTabcontainer.cleanup();
        }
    }
}

let experienceEditor = $('.is-experience-editor');

if (!experienceEditor.length) {
	mqL.addListener(ingredientHeaderSticky);
	ingredientHeaderSticky();
}